export default "__VITE_ASSET__B9NwEPq5__"